import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2487">
      <Navbar data-id="element-2488" />
      <main data-id="element-2489">
        <ConsularAffairs data-id="element-2490" />
      </main>
      <Footer data-id="element-2491" />
      <FeedbackPopup data-id="element-2492" />
    </div>;
}